var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"main flex flex-direction",class:{fixed:!_vm.isScroll}},[_c('router-view')],1),_c('div',{staticClass:"foot-box"},[_c('footPage')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }